import { configureStore } from '@reduxjs/toolkit';
import snackbarReducer from './reducer/snackbarSlice';
import authUserReducer from './reducer/authUserSlice';
import drawerReducer from './reducer/drawerSlice';
import dialogReducer from './reducer/dialogSlice';
import modalReducer from './reducer/modalSlice'
import permissionReducers from './reducer/permissionSlice';
import financialYearReducer from "./reducer/financialYearSlice";
import sortingReducer from "./reducer/sortingSlice";
import tableSearchReducer from "./reducer/tableSearchSlice"; 
import showFiltersReducer from "./reducer/showFiltersSlice";
import refreshReducer from "./reducer/masters/refreshSlice";
import addProductReducer from "./reducer/quotation/productSlice";
import mastersReducer from "./reducer/masters/mastersSlice";
import folderReducer from './reducer/archive/folderSlice'
import activeInvoiceReducer from './reducer/invoice/activeInvoiceSlice'
import navigationStateReducer from './reducer/invoice/navigationState'
import customerConfigReducer from './reducer/customerConfigSlice';

const store = configureStore({
    reducer: {
        snackbar: snackbarReducer,
        authUser: authUserReducer,
        drawer: drawerReducer,
        dialog: dialogReducer,
        modal: modalReducer,
        permission: permissionReducers,
        financialYear: financialYearReducer,
        sorting: sortingReducer,
        tableSearch: tableSearchReducer,
        showFilters: showFiltersReducer,
        refresh: refreshReducer,
        masters: mastersReducer,
        product:addProductReducer,
        activeInvoice: activeInvoiceReducer,
        folder: folderReducer,
        navigation: navigationStateReducer,
        customerConfig: customerConfigReducer,
    }
});

export type AppDispatch = typeof store.dispatch;

export type RootState = ReturnType<typeof import('./store').default.getState>

export default store;